<template>
  <div class="submission">
    <div class="submission_top">
      <span>Your registration is almost complete!</span>
      <div class="submission_top_img">
        <img src="../../../../assets/images/payment.png" alt="payment" />
      </div>
      <p>
        You are required to pay a sum of N 3,000 for administration and
        verification. <span>Only</span> verified candidates will be invited for
        interviews by our clients.
      </p>
      <div class="submission_top_btn">
        <div
          class="submission_top_btn_card"
          v-if="!btnLoader"
          @click="makePayment"
        >
          Pay Now
        </div>
        <div class="submission_top_btn_card" v-if="btnLoader">
          <WhiteLoader />
        </div>
        <div class="submission_top_btn_transfer" @click="modal = true">
          Pay Via Transfer
        </div>
      </div>
    </div>
    <div class="submission_btm">
      <p>
        GET 50% Discount when you share this link with your family and friends
        and they signup:
      </p>
      <div class="submission_btm_form">
        <input type="text" />
        <button>Copy Link</button>
      </div>
      <span>Share this on:</span>
      <div class="submission_btm_share">
        <div>
          <div>
            <img src="../../../../assets/images/facebook.svg" alt="facebook" />
          </div>
          <div>
            <img src="../../../../assets/images/whatsapp.svg" alt="whatsapp" />
          </div>
        </div>
      </div>
    </div>

    <div class="submission_modal" v-if="modal">
      <div>
        <div class="submission_modal_container">
          <p>
            <span @click="modal = false">
              <font-awesome-icon icon="times"
            /></span>
          </p>
          <div>
            <img src="../../../../assets/images/museum.svg" alt="bank" />
            <p>
              Pay To Our Bank Account
            </p>
            <div>
              <p><span>Bank:</span> Guaranty Trust Bank (GTB)</p>
              <p><span>Account Number:</span> 0138813931</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../../store/constant";
import WhiteLoader from "../../../partials/white-loader";

export default {
  name: "Submission",
  components: {
    WhiteLoader
  },
  data() {
    return {
      item: "profile",
      btnLoader: false,
      modal: false,
      formData: {
        amount: 3000,
        reference: "",
        mode: "paystack",
        provider_reference: ""
      }
    };
  },
  methods: {
    showPayment() {
      this.$emit("clickedPay");
    },
    showModal() {
      console.log("modal");
    },
    generateReference() {
      this.formData.reference = "" + Math.floor(Math.random() * 1000000000 + 1);
    },
    makePayment() {
      
    },
    sendToBackend() {
      this.$http.post(types.JOBSEEKER_PAY, this.formData).then(resp => {
        this.btnLoader = false;
        this.showPayment();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.submission {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 50px;

  > .submission_top {
    border-bottom: 1px solid #ccc;
    text-align: center;
    padding-bottom: 50px;

    > span {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: left;
      color: #f79320;
    }

    > .submission_top_img {
      width: 50px;
      margin: 30px auto;

      > img {
        width: 100%;
      }
    }

    > p {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      max-width: 700px;
      margin: auto;

      > span {
        color: #f79320;
        font-weight: 600;
      }
    }

    > .submission_top_btn {
      margin: 30px auto 0 auto;
      width: 450px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-content: center;

      > .submission_top_btn_card {
        width: 200px;
        height: 40px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }

      > .submission_top_btn_transfer {
        width: 200px;
        height: 40px;
        border-radius: 5px;
        border: 1px solid #5099de;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: center;
        color: #5099de;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }
    }
  }

  > .submission_btm {
    background-color: #fafafa;
    margin-top: 30px;
    padding: 50px 10px;
    text-align: center;

    > p {
      max-width: 500px;
      font-size: 16px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.46;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      margin: auto;
    }

    > .submission_btm_form {
      max-width: 700px;
      margin: 20px auto;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      border-radius: 3px;
      overflow: hidden;

      > input {
        width: 70%;
        height: 40px;
        background-color: #ffffff;
        outline: 0;
        padding: 0 5px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;
        color: #707070;
        border: solid 1px #c7c7c7;
      }

      > button {
        width: 30%;
        height: 40px;
        background-color: #5099de;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        border: solid 1px #c7c7c7;
        outline: 0;
      }
    }

    > span {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    > .submission_btm_share {
      margin-top: 20px;
      > div {
        width: 100px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;
        margin: auto;

        > div {
          width: 40px;
          cursor: pointer;
        }
      }
    }
  }

  > .submission_modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: auto;

    > div {
      max-width: 600px;
      margin: 150px auto;
      padding: 0 10px;

      > .submission_modal_container {
        background-color: #fff;
        padding: 20px;

        > p {
          text-align: right;
          > span {
            color: #000;
            cursor: pointer;
          }
        }

        > div {
          text-align: center;

          > img {
            width: 50px;
            margin: 20px 0 10px 0;
          }

          > p {
            font-size: 16px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.46;
            letter-spacing: normal;
            text-align: center;
          }

          > div {
            border-top: 1px solid #ddd;
            padding-top: 30px;

            > p {
              max-width: 250px;
              color: #000;
              font-size: 16px;
              font-weight: 600;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.46;
              letter-spacing: normal;
              text-align: left;
              margin: 0 auto 10px;

              > span {
                color: #f79320;
              }
            }
          }
        }
      }
    }
  }
}
</style>
